var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "images-number-box" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Number of images"))),
      ]),
      _vm._v(" "),
      _vm.projectName === "Img2Go"
        ? _c(
            "strong",
            {
              staticClass: "badge badge-starter d-flex align-items-center",
              on: { click: _vm.handleProOrChange },
            },
            [_vm._v(_vm._s(_vm._f("trans")("STARTER")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.projectName !== "Img2Go"
        ? _c(
            "strong",
            {
              staticClass: "badge badge-warning d-flex align-items-center",
              on: { click: _vm.handleProOrChange },
            },
            [_vm._v(_vm._s(_vm._f("trans")("PREMIUM")))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "images-number-container" },
      _vm._l(_vm.numberOfImages, function (obj) {
        return _c(
          "div",
          {
            staticClass: "images-number-btn",
            class: {
              active: _vm.isActive(obj.number),
              disabled:
                _vm.isFreeUser && obj.number > 2 && !_vm.isActive(obj.number),
            },
            on: {
              click: function ($event) {
                return _vm.handleProOrChange(obj.number)
              },
            },
          },
          [
            _c("strong", [_vm._v(_vm._s(obj.number))]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "checkmark-box",
                class: {
                  active: _vm.isActive(obj.number),
                  disabled: _vm.isFreeUser && !_vm.isActive(obj.number),
                },
              },
              [_c("i", { staticClass: "fa fa-check" })]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }